var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGradientCollectibles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8586 52.6708L16.8689 52.6884C15.8166 52.6884 14.963 51.8261 14.963 50.7621L14.9543 23.756C14.9543 22.692 15.8078 21.8269 16.8572 21.8269L56.847 21.8093C57.8992 21.8093 58.7528 22.6716 58.7528 23.7385L58.7616 50.7446C58.7616 51.8057 57.911 52.6708 56.8586 52.6708ZM11.1391 14.1103C9.03747 14.1132 7.33337 15.8407 7.33337 17.9687L7.34799 56.5502C7.35091 58.6811 9.05209 60.4056 11.1597 60.4056L62.576 60.3852C64.6805 60.3822 66.3846 58.6547 66.3846 56.5268L66.3671 17.9453C66.3671 15.8144 64.663 14.0898 62.5584 14.0898L11.1391 14.1103ZM80.6665 68.1254V25.6685C80.6665 24.6016 79.813 23.7393 78.7636 23.7393H74.9519C73.8996 23.7393 73.046 24.6016 73.046 25.6685V62.3351C73.046 64.466 71.3419 66.1935 69.2374 66.1935H25.4298C24.3775 66.1935 23.5239 67.0557 23.5239 68.1227V71.981C23.5239 73.048 24.3774 73.9102 25.4298 73.9102H74.9551C78.1061 73.9131 80.6667 71.3234 80.6667 68.1255L80.6665 68.1254ZM28.0252 46.8955H44.5342C45.7092 46.8955 46.3552 45.4632 45.6128 44.5074L37.3583 33.9227C36.8 33.2095 35.7594 33.2095 35.2011 33.9227L26.9466 44.5096C26.2042 45.4625 26.8531 46.8948 28.0252 46.8948V46.8955ZM45.929 27.5976C43.7981 27.5976 42.0706 29.3251 42.0706 31.456C42.0706 33.5868 43.7981 35.3144 45.929 35.3144C48.0599 35.3144 49.7874 33.5868 49.7874 31.456C49.7903 29.3251 48.0628 27.5976 45.929 27.5976Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 115.088,
    y1: 43.3895,
    x2: 57.6835,
    y2: -26.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B23E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22FEB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGradientCollectibles);
export default __webpack_public_path__ + "static/media/iconGradientCollectibles.dc19cb0e.svg";
export { ForwardRef as ReactComponent };